import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import ModernCardHeaderLable from './ModernCardHeaderLable';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Rating from '@mui/material/Rating';

import AddIcon from '@mui/icons-material/Add';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';

type ProductCardProps = {
	product: {
		id: number;
		name: string;
		img: string;
		price: number;
		rating: number;
	};
};

// Todo: Add a original price in the products data.
// Todo: Decompose the code.
// Todo: Provide information for the "alt" attribute.

function ModernProductCard({ product }: ProductCardProps): JSX.Element {
	const navigate = useNavigate();

	const onClickProduct = useCallback(() => {
		navigate('/can-store/product');
	}, [navigate]);

	return (
		<Card
			sx={{
				maxWidth: '275px',
				display: 'flex',
				flexDirection: 'column',
				gap: '1rem',
				borderRadius: '15px',
			}}
		>
			<CardHeader component={ModernCardHeaderLable} />
			<CardMedia
				component="img"
				image={product.img}
				alt="img"
				onClick={onClickProduct}
				sx={{
					width: '225px',
					height: '225px',
					margin: 'auto',
					cursor: 'pointer',
				}}
			/>
			<Divider />
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '0.25rem',
					paddingTop: '0px',
					paddingBottom: '0px',
				}}
			>
				<Box component="div" sx={{ fontWeight: 'bold', color: 'var(--csmd-cl-text-primary)' }}>
					{product.name}
				</Box>
				<Box component="div" sx={{ display: 'flex', alignItems: 'center' }}>
					<Rating name="read-only" value={product.rating} readOnly size="small" />
					<Box component="p" sx={{ paddingLeft: '10px' }}>
						({product.rating}.0)
					</Box>
				</Box>
				<Box
					component="div"
					sx={{ fontSize: '1rem', fontWeight: 'bold', color: 'var(--csmd-cl-primary-main)' }}
				>
					<Box
						component="span"
						sx={{
							fontWeight: 'bold',
							color: 'var(--csmd-cl-primary-main)',
							paddingRight: '0.25rem',
						}}
					>
						$
					</Box>
					{product.price}
					<Box
						component="span"
						sx={{
							color: 'var(--csmd-cl-text-primary)',
							paddingLeft: '1rem',
							textDecoration: 'line-through',
						}}
					>
						$42.99
					</Box>
				</Box>
			</CardContent>
			<CardActions
				sx={{
					display: 'flex',
					gap: '1rem',
					justifyContent: 'space-between',
					paddingTop: '0px',
					paddingBottom: '20px',
				}}
			>
				<Button
					variant="contained"
					startIcon={<AddIcon />}
					size="small"
					fullWidth
					sx={{ bgcolor: 'var(--csmd-cl-primary-main)' }}
				>
					Add To Cart
				</Button>
				<Avatar
					sx={{ bgcolor: 'var(--csmd-cl-primary-main)', width: '32.5px', height: '32.5px' }}
					variant="rounded"
				>
					<FavoriteBorderIcon />
				</Avatar>
			</CardActions>
		</Card>
	);
}

export default ModernProductCard;
